import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';


@Component({
  selector: 'app-InvoiceDetail',
  templateUrl: './InvoiceDetail.component.html',
  styleUrls: ['./InvoiceDetail.component.scss']
})
export class InvoiceDetailComponent implements OnInit {
  paymentMode: any[]=[];
  serviceMode: any[] = [];
  currentUser: any;
  

  constructor(public dialog: MatDialog, public tokenStorageService: TokenStorageService, private router: Router, private authService: AuthService,
    private toastr: ToastrService, public dialogRef: MatDialogRef<InvoiceDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public ezipayRefrenceid: any
  ) {  }

  ngOnInit() {
    

    this.currentUser = this.tokenStorageService.getUser();
    if (this.currentUser) {
      this.InvoiceDetail(this.ezipayRefrenceid);
    }
  }

  /**InvoiceDetail */
  InvoiceDetail(ezipayRefrenceid: any) {

    this.authService.getUserOrdersdetailsByUserId(ezipayRefrenceid, this.currentUser.serviceid).subscribe(response => {
      
      if (response.apiStatus == true) {

        
        this.serviceMode.push(response.apiData.serviceMode);
        this.paymentMode.push(response.apiData.paymentMode);
      }
      
      else {
      
        this.toastr.error(response.apiMessage, "Error");
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }
}
